import ProtectedEnvironmentsTable from './ProtectedEnvironmentsTable';

export default ProtectedEnvironmentsTable;
